import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-button-renderer',
  template: `
    <wsb-atlas-button
      *ngIf="!hide"
      class="mb-2 {{ classes }}"
      [disabled]="disabled"
      [variant]="variant"
      [label]="label"
      (click)="onClick($event)"
      [icon]="icon"
    >
      {{ label | translate }}
    </wsb-atlas-button>
  `,
  standalone: false
})
export class ButtonRendererComponent implements ICellRendererAngularComp {
  params;
  label: string;
  variant: string;
  icon: string | null;
  hide: boolean;
  classes = '';
  disabled = false;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    this.variant = this.params.variant || 'danger';
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params.data) : false;
    this.icon = this.params.icon || null;
    this.classes = this.params.classes || '';
    this.disabled = this.params.disabled
      ? this.params.disabled instanceof Function
        ? this.params.disabled()
        : this.params.disabled
      : false;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
